import React, { useEffect, useLayoutEffect, useState } from 'react';
import { logError } from "../utils/builder/IAmecLog";
import { cloneDeep } from 'lodash';

export const updateFilters = (res) => {
  const deepCopy = cloneDeep(res);

  for (const key in deepCopy) {
    if (!deepCopy[key]) {
      delete deepCopy[key]
    }
  }

  return deepCopy;
};

//   items filtering by search
export const searchByText = (list, value) => {
  if (!value) {
    return list;
  }
  const newlist = list.filter((el) => {
    if (typeof el === "string") {
      return el.toLowerCase().includes(value.toLowerCase());
    }
    return (
      el.text.toLowerCase().includes(value.toLowerCase()) ||
      el.type.toString().includes(value.toString())
    );
  });
  return newlist;
};
//  table items filtering by search
export const searchBy = (arr, value) => {
  if (!value) {
    return arr;
  }
  return arr.filter((list) => {
    const condition = list.find((el) => {
      if (typeof el === "string") {
        return el.toLowerCase().includes(value.toLowerCase());
      }
      return value.toLowerCase() == el;
    });
    return condition;
  });
};

export const searchInlines = (arr, value) => {
  if (!value) {
    return arr;
  }

  return arr.filter(({ lines }) => {
    const condition = lines.find((el) => {
      if (typeof el === "string") {
        return el.toLowerCase().includes(value.toLowerCase());
      }

      return value.toLowerCase() == el;
    });
    
    return condition;
  });
};

export const toArray = (obj) => {
  let arr = [];
  for (const key in obj) {
    arr = [...arr, ...obj[key]];
  }
  return arr;
};

// tree  state saving & searching
const setFun = (list) => {
  let tempObj = {};
  list.map((el) => (tempObj[el.id] = {}));
  return tempObj;
};

export const treeAdd = (object, value, list, condition, level) => {
  if (level === 1) {
    return { ...object, [value]: condition ? setFun(list) : {} };
  }
  if (Object.keys(object).length === 0) {
    object = condition ? { [value]: setFun(list) } : {};
  } else {
    for (const key in object) {
      if (value === key) {
        object[value] = condition ? setFun(list) : {};
        return object;
      }
    }

    for (const key in object) {
      treeAdd(object[key], value, list, condition);
    }
  }

  return object;
};
//
export let searchTreeCondition = false;

export const searchTreeFun = (tree, id) => {
  let condition = false;

  const bodyFun = (tree, id) => {
    if (Object.keys(tree).length !== 0) {
      for (const key in tree) {
        if (id === key) {
          if (Object.keys(tree[key]).length !== 0) {
            return (condition = true);
          }
        }
      }
      for (const key in tree) {
        bodyFun(tree[key], id);
      }
    }
    return condition;
  };
  return bodyFun(tree, id);
};

export const searchLevel = async (value, getNextLevel, id) => {
  let condition;
  try {
    let list = await getNextLevel(id);
    if (!value) {
      return {
        list,
        condition: false,
      };
    }
    const newList = list.filter((el) => {
      const elCondition = el.text.toLowerCase().includes(value.toLowerCase());
      if (elCondition) {
        condition = true;
      }
      return elCondition;
    });
    return {
      list: newList,
      condition: condition,
    };
  } catch (err) {
    logError("FrontEnd.src.utils.helper.searchLevel", err.toString());
  }
};

export const findFoldersTreeObj = (id, treeItem) => {
  if (Array.isArray(treeItem)) {
    const idIndex = treeItem.findIndex(item => item.id == id);

    if (idIndex >= 0) {
      return treeItem[idIndex];
    } else {
      let obj = null;

      treeItem.some(treeArrItem => {
        const reqObj = findFoldersTreeObj(id, treeArrItem);

        if (reqObj) {
          obj = reqObj;
        }
      });

      return obj;
    }
  } else {
    if (treeItem.hasOwnProperty('childrenArr')) {
      const reqObj = findFoldersTreeObj(id, treeItem.childrenArr);

      if (reqObj) {
        return reqObj;
      }
    }
  }
};

export const getFoldersBreadcrumbs = (id, treeItem) => {
  if (Array.isArray(treeItem)) {
    const idIndex = treeItem.findIndex(item => item.id == id);

    if (idIndex >= 0) {
      return [ treeItem[idIndex] ];
    } else {
      let arr = null;

      treeItem.some(treeArrItem => {
        const reqArr = getFoldersBreadcrumbs(id, treeArrItem);

        if (reqArr?.length) {
          arr = [treeArrItem, ...reqArr];
        }
      });

      if (arr?.length) {
        return arr;
      }
    }
  } else {
    if (treeItem.hasOwnProperty('childrenArr')) {
      const reqArr = getFoldersBreadcrumbs(id, treeItem.childrenArr);

      if (reqArr?.length) {
        return reqArr;
      }
    }
  }
};

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export const useElementSize = (element) => {
  const [size, setSize] = useState([0, 0]);

  useLayoutEffect(() => {
    const updateSize = () => {
      setSize([element?.offsetWidth, element?.offsetHeight]);
    };

    window.addEventListener('resize', updateSize);

    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, [element]);

  return size;
};

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

